<a ng-doc-button-text [routerLink]="route" target="_blank">
	<span ng-doc-text>
		Open demo in a new tab
		<ng-doc-icon icon="external-link" ngDocTextRight></ng-doc-icon>
	</span>
</a>
